import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.Statement.UploadFile.IRequest;
type Response = Api.Core.Statement.UploadFile.IResponse;
type Headers = Api.Core.Statement.UploadFile.IHeaders;
const apiStatementUploadFilePath = '/api/DealerManagement/Statement/:id/UploadFile';
export default async function statementUploadFileApi(id: number, request: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    body: request,
    url: createPathFromRoute(apiStatementUploadFilePath, { id }),
    method: HttpMethod.post,
    headers: getDefaultHeaders(),
  });
}
